import axios from 'axios';
import Page from '../../lib/page';
import { trackPage } from '../../lib/analytics-helper';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default function updateBnaData(articleInfo) {
  if (Page.isLoggedIn()) {
    const { bnaListId = '', bnaId = '', intentCode = '' } = articleInfo.channelDetails || {};
    if (bnaListId && bnaId && intentCode) {
      // setting a flag in localstorage for bna articles. True if bna article is clicked
      window.localStorage.setItem('isBNA', true);
      return axios
        .post('/smarthelp/update-bna-data', {
          _csrf: Page.getCSRFtoken(),
          bnaListId,
          bnaId,
          intentCode,
        })
        .then(() => {
          trackPage({ id: 'updateBNA', hpid: articleInfo.articleId });
        })
        .catch(() => {
          trackPage({ id: 'updateBNAError', hpid: articleInfo.articleId });
        }); // Catch BNA error for solving unhandle promise reject issue
    }
  }
  return undefined;
}
// }
